import script from "./ChartRoadTo2050.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartRoadTo2050.vue?vue&type=script&setup=true&lang=js"

import "./ChartRoadTo2050.vue?vue&type=style&index=0&id=05fc87ca&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fc87ca"]])

export default __exports__